// api.js

// const BASE_URL = window.curProInfo.BASE_URL;
const APP_KEY = window.curProInfo.APP_KEY;
const API_KEY = window.curProInfo.API_KEY;

const API_URL = window.curProInfo.API_URL;
const appKey = window.curProInfo.appKey;
const appSecret = window.curProInfo.appSecret;
//获取token
export const getToken = async () => {
  const response = await fetch(
    `${API_URL}/token?appKey=${appKey}&appSecret=${appSecret}`,
    {
      method: "GET",
      // 根据实际情况，可能需要添加请求头或者其他参数，比如如果通过地址传递appKey和appSecret，如下
      headers: {
        "Content-Type": "application/json",
        appKey: appKey,
        appSecret: appSecret,
      },
    }
  );

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`获取token失败：${response.status} - ${errorText}`);
  }

  const jsonData = await response.json();

  return jsonData.data.token; // 假设返回的数据结构中token字段存放获取到的token，按实际调整
};

//创建工单
export const createResult = async (taskId, token) => {
  const headers = {
    "Content-Type": "application/json",
    appKey: appKey,
    appSecret: appSecret,
    AuthorizationToken: token, // 假设使用Bearer认证方式携带token，按实际情况修改
  };

  const response = await fetch(`${API_URL}/bot/createResult?taskId=${taskId}`, {
    method: "GET",
    headers,
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`发起工单失败：${response.status} - ${errorText}`);
  }

  const jsonData = await response.json();
  return jsonData; // 根据实际返回的数据结构返回相应内容，比如工单创建成功的相关信息等
};

//创建工单
export const createWorkOrder = async (workOrderData, token) => {
  const headers = {
    "Content-Type": "application/json",
    appKey: appKey,
    appSecret: appSecret,
    AuthorizationToken: token, // 假设使用Bearer认证方式携带token，按实际情况修改
  };

  const response = await fetch(`${API_URL}/bot/submitWorkOrder2`, {
    method: "POST",
    headers,
    body: JSON.stringify(workOrderData),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`发起工单失败：${response.status} - ${errorText}`);
  }

  const jsonData = await response.json();
  return jsonData; // 根据实际返回的数据结构返回相应内容，比如工单创建成功的相关信息等
};



const getUserID = () => {
  // let userID = localStorage.getItem("userID");
  // if (!userID) {
  //   userID =
  //     "user_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9);
  //   localStorage.setItem("userID", userID);
  // }
  return "admin";//userID;
};

const USER_ID = getUserID();

const createConversation = async () => {
  let token = await getToken();
  const data = {
    AppKey: APP_KEY,
    Inputs: {},
    UserID: USER_ID,
  };
  const response = await fetch(`${API_URL}/chat/create_conversation`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Apikey: API_KEY,
      appKey: appKey,
      appSecret: appSecret,
      AuthorizationToken: token,
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`创建会话失败：${response.status} - ${errorText}`);
  }
  const jsonData = await response.json();
  if (jsonData.code!==200) {
    throw new Error("创建会话失败：无效的响应数据");
  }
  const conversationID = jsonData.data.conversationId;
  localStorage.setItem("AppConversationID", conversationID);
  return conversationID;
};

const getAppConversationID = async (flat = false) => {
  let conversationID
  if (flat) {
    conversationID = localStorage.getItem("historysessionId")
  } else {
    conversationID = localStorage.getItem("AppConversationID")
  }
  if (!conversationID) {
    conversationID = await createConversation();
  }
  return conversationID;
};

export const chatQuery = async (query, onMessage, onError) => {
  const AppConversationID = await getAppConversationID();
  const data = {
    "content": query,
    "conversationId":AppConversationID
  };
  let token = await getToken();
  try {
    const response = await fetch(`${API_URL}/chat/chat_query`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Apikey: API_KEY,
        appKey: appKey,
        appSecret: appSecret,
        AuthorizationToken: token,
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`网络响应失败：${response.status} - ${errorText}`);
    }

    // const reader = response.body.getReader();
    // const decoder = new TextDecoder("utf-8");
    // let buffer = "";
    // let fullContent = "";

    // while (true) {
    //   const { done, value } = await reader.read();
    //   if (done) break;
    //   buffer += decoder.decode(value, { stream: true });

    //   // 按行分割数据
    //   let lines = buffer.split(/\r?\n/);
    //   buffer = lines.pop(); // 保留未完成的行

    //   for (let line of lines) {
    //     line = line.trim();
    //     if (line === "") {
    //       continue; // 跳过空行
    //     }

    //     // 去除所有的 'data:' 前缀
    //     line = line.replace(/^(data:)+\s*/, "");
    //     if (line === "") {
    //       continue; // 跳过去除前缀后为空的行
    //     }
    //     if (line === "[DONE]") {
    //       // 结束标志
    //       break;
    //     }

    //     try {
    //       const jsonData = JSON.parse(line);
    //       if (jsonData.event === "message" && jsonData.answer) {
    //         // 只提取 message 事件中的 answer 字段
    //         const content = jsonData.answer;
    //         fullContent += content; // 累加内容
    //         // 不再在这里调用 onMessage
    //       }
    //     } catch (error) {
    //       console.error("解析 JSON 出错：", error, "原始数据：", line);
    //     }
    //   }
    // }
    const jsonData = await response.json();
  if (jsonData.code!==200) {
    throw new Error("失败：无效的响应数据");
  }
  const fullContent = jsonData.data.answer;
    // 在接收到所有数据后，调用 onMessage 一次
    onMessage(fullContent);
  } catch (error) {
    console.error("请求出错：", error);
    onError(error);
  }
};

// 添加获取会话历史消息的函数
export const getConversationMessages = async (limit = 10, flat = false) => {
  const AppConversationID = await getAppConversationID(flat);

  const data = {
    // AppKey: APP_KEY,
    "conversationId":AppConversationID,
    // Limit: limit,
    // UserID: USER_ID,
  };
  let token = await getToken();
  try {
    const response = await fetch(`${API_URL}/chat/get_conversation_messages?conversationId=${AppConversationID}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Apikey: API_KEY,
        appKey: appKey,
        appSecret: appSecret,
        AuthorizationToken: token,
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `获取会话历史消息失败：${response.status} - ${errorText}`
      );
    }

    const jsonData = await response.json();
    if (jsonData.code!==200) {
      throw new Error("失败：无效的响应数据");
    }

    return (jsonData.data&&jsonData.data.Messages) || [];
  } catch (error) {
    console.error("获取会话历史消息出错：", error);
    throw error;
  }
};


//文件上传// 文件上传
export const wbbUpload = async (token, formData) => {
  // 创建 FormData 对象并附加文件
  // "file" 需与后端接口要求的字段名一致

  // 设置正确的请求头（移除手动 Content-Type）
  const headers = {
    appKey: appKey,
    appSecret: appSecret,
    AuthorizationToken: token, // 假设使用 Bearer 方案
  };

  try {
    const response = await fetch(`${API_URL}/bot/wbb/upload`, {
      method: "POST",
      headers,
      body: formData, // 发送 FormData
    });

    if (!response.ok) {
      // 尝试解析错误信息（假设服务器返回 JSON 格式的错误信息）
      const errorData = await response.json();
      throw new Error(`上传失败：${errorData.message || response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    // 统一错误处理（如网络错误）
    throw new Error(`请求失败：${error.message}`);
  }
};

